import { render } from "./SidebarMenuBadge.vue?vue&type=template&id=54dd2f1e&ts=true"
import script from "./SidebarMenuBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenuBadge.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarMenuBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54dd2f1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54dd2f1e', __exports__)) {
    api.reload('54dd2f1e', __exports__)
  }
  
  module.hot.accept("./SidebarMenuBadge.vue?vue&type=template&id=54dd2f1e&ts=true", () => {
    api.rerender('54dd2f1e', render)
  })

}


export default __exports__